import { defaultGroupRaycast, skipHiddenSubtreeRaycast } from './pickVisibleHit';

/** Apply visibility + opacity on a loaded Object3D tree (GLB meshes). */
export function applyLayerAppearance(root, { visible = true, opacity = 1 } = {}) {
  if (!root) return;
  const on = !!visible;
  root.visible = on;
  // Three.js r160+ raycasts hidden objects; returning false skips the subtree.
  root.raycast = on ? defaultGroupRaycast : skipHiddenSubtreeRaycast;
  const o = Math.max(0.05, Math.min(1, Number(opacity) || 1));
  root.traverse((obj) => {
    if (!obj.isMesh || !obj.material) return;
    const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
    mats.forEach((mat) => {
      if (!mat) return;
      mat.transparent = o < 0.999;
      mat.opacity = o;
      mat.depthWrite = o >= 0.999;
      mat.needsUpdate = true;
    });
  });
}
